import { transliterate } from 'transliteration';

const transliteration = {
  toKeyFormat: (text: string) => transliterate(text).toLowerCase().replace(/\s+/g, '_'),
};

export default transliteration;
